import type { SystemStyleObject } from '@chakra-ui/react'
import { Box } from '@chakra-ui/react'
import { useWindowHeight } from '@react-hook/window-size'

export const PageContent = ({ children, sx, ...rest }: { children: React.ReactNode, sx?: SystemStyleObject }) => {
  const height = useWindowHeight()

  // 229 pixelů je magická hodnota odpovídacící výšce headeru a footeru plus paddingu.



  return (
    <Box sx={{ display: 'grid', gap: 8, placeItems: 'start', justifyItems: 'stretch', alignContent: 'start', minHeight: { base: height - 329, xl: height - 229 }, ...sx }} {...rest}>
      {children}
    </Box>
  )
}
